module.exports = {
    API_BASE_URL: 'https://api.nordquists.com/'
}